var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"How it works mobile","src":_vm.mobileImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }